(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4933,598,5182,4229,8425],{

/***/ 60714:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ APIErrorMessage; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./src/global/AlertErrorMessage/index.js + 1 modules
var AlertErrorMessage = __webpack_require__(25516);
// EXTERNAL MODULE: ./src/constants/errorMessage.js
var errorMessage = __webpack_require__(61608);
// EXTERNAL MODULE: ./src/config/APIErrorMessage/utils.ts
var utils = __webpack_require__(63858);
;// CONCATENATED MODULE: ./src/config/APIErrorMessage/handler.js





/**
 * handleDefault
 * @param {*} errorType | optional
 * @param {*} message | optional
 * @param {*} singleError  | optional
 */ var handleDefault = function(errorType, message) {
    if (errorType === errorMessage/* default.PAYWALL_NOSUBSCRIPTION */.Z.PAYWALL_NOSUBSCRIPTION) return;
    if (errorType === errorMessage/* default.FORBIDDEN */.Z.FORBIDDEN) return;
    var errMessageDefault = message;
    (0,AlertErrorMessage/* default */.Z)(errMessageDefault, errorMessage/* default.ALERT_RED */.Z.ALERT_RED);
};
/**
 * handleMaintenance
 * web legacy: app\lib\Api.js line 184
 * @param {*} errorType | MAINTENANCE | ERROR_GATEWAY
 * @param {*} message | optional
 * @param {*} singleError  | optional
 */ var handleMaintenance = function(errorType, message) {
    if (errorType === "MAINTENANCE" && message) {
        (0,utils/* dispatchSetErrorCode */.S)(503, message);
    }
};
/**
 * handleUnAuthorized
 * web legacy: app\lib\Api.js line 192
 * @param {*} errorType | optional
 * @param {*} message | optional
 * @param {*} singleError  | optional
 */ var handleInvalidParameter = function(_, message) {
    (0,AlertErrorMessage/* default */.Z)(message, errorMessage/* default.ALERT_RED */.Z.ALERT_RED);
};
/**
 * handleInternalServerError
 * @param {*} errorType | optional
 * @param {*} message | optional
 * @param {*} singleError  | optional
 */ // eslint-disable-next-line no-unused-vars
var handleInternalServerError = function(_, message) {
    (0,utils/* dispatchSetErrorCode */.S)(500);
};
/**
 * handleNotFound
 * @param {*} errorType | optional
 * @param {*} message | optional
 * @param {*} singleError  | optional
 */ var handleNotFound = function(_, message) {
    (0,AlertErrorMessage/* default */.Z)(message, errorMessage/* default.ALERT_RED */.Z.ALERT_RED);
};
/**
 * handleNotSubscription
 * web legacy: app\lib\Api.js line 238
 * @param {*} errorType | optional
 * @param {*} message | optional
 * @param {*} singleError  | optional
 */ var handleNotSubscription = function() {
// TODO: url
};
/**
 * @deprecated 401 Unathorized is directly handled from API instance
 * handleUnAuthorized
 * @param {Promise} originalRequest
 * @return Promise originalRequest with new Authorization header or error rejection
 */ // eslint-disable-next-line @typescript-eslint/no-empty-function
var handleUnAuthorized = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(originalRequest) {
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function handleUnAuthorized(originalRequest) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ var handler = ({
    handleDefault: handleDefault,
    handleMaintenance: handleMaintenance,
    handleInvalidParameter: handleInvalidParameter,
    handleNotFound: handleNotFound,
    handleNotSubscription: handleNotSubscription,
    handleUnAuthorized: handleUnAuthorized,
    handleInternalServerError: handleInternalServerError
});

;// CONCATENATED MODULE: ./src/config/APIErrorMessage/index.js

var APIErrorMessage_handleDefault = handler.handleDefault, APIErrorMessage_handleMaintenance = handler.handleMaintenance, APIErrorMessage_handleInvalidParameter = handler.handleInvalidParameter, APIErrorMessage_handleNotFound = handler.handleNotFound, APIErrorMessage_handleNotSubscription = handler.handleNotSubscription, APIErrorMessage_handleUnAuthorized = handler.handleUnAuthorized, APIErrorMessage_handleInternalServerError = handler.handleInternalServerError;
/**
 * Exodus API error message handler
 * @param {number} status - HTTP Response status | required
 * @param {string} errorType - Error types | required
 * @param {string} message - Error message | required
 */ var APIExodusErrorHandler = function(status, errorType, message) {
    var listErrorResponse = {
        DEFAULT: APIErrorMessage_handleDefault,
        400: APIErrorMessage_handleInvalidParameter,
        401: APIErrorMessage_handleUnAuthorized,
        402: APIErrorMessage_handleNotSubscription,
        404: APIErrorMessage_handleNotFound,
        500: APIErrorMessage_handleInternalServerError,
        503: APIErrorMessage_handleMaintenance
    };
    var response = listErrorResponse[status] || listErrorResponse.DEFAULT;
    return response(errorType, message);
};
/* harmony default export */ var APIErrorMessage = ({
    APIExodusErrorHandler: APIExodusErrorHandler
});


/***/ }),

/***/ 63858:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ dispatchSetErrorCode; }
/* harmony export */ });
/* harmony import */ var global_MainLayout_store__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(73580);
/* eslint-disable import/prefer-default-export */ 
var dispatchSetErrorCode = function(errorCode) {
    var errorMessage = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    global_MainLayout_store__WEBPACK_IMPORTED_MODULE_0__/* ["default"].setState */ .Z.setState({
        errorCode: errorCode,
        errorMessage: errorMessage
    });
};


/***/ }),

/***/ 14350:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "RL": function() { return /* binding */ getAccessTokenDataFn; },
/* harmony export */   "oD": function() { return /* binding */ getRefreshTokenConfigFn; },
/* harmony export */   "x5": function() { return /* binding */ refreshExodusToken; }
/* harmony export */ });
/* unused harmony export initialRefreshTokenConfig */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47568);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var utils_auth__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14229);
/* harmony import */ var constants_api__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(37213);





var initialRefreshTokenConfig = {
    refreshingTokenStatus: "initial",
    refreshAndRetryQueue: []
};
var getRefreshTokenConfigFn = function() {
    var initNewConfig = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    if (true) {
        if (initNewConfig) {
            window.refreshRequestConfig = {
                refreshingTokenStatus: "initial",
                refreshAndRetryQueue: []
            };
            return window.refreshRequestConfig;
        }
        if (typeof window.refreshRequestConfig !== "undefined") {
            return window.refreshRequestConfig;
        }
        return undefined;
    }
    return initialRefreshTokenConfig;
};
var getAccessTokenDataFn = function() {
    var ref, ref1, ref2, ref3;
    var parsedToken = utils_auth__WEBPACK_IMPORTED_MODULE_2__/* ["default"].getToken */ .Z.getToken();
    var accessToken = (parsedToken === null || parsedToken === void 0 ? void 0 : (ref = parsedToken.accessToken) === null || ref === void 0 ? void 0 : ref.token) || "";
    var accessTokenExpiry = (parsedToken === null || parsedToken === void 0 ? void 0 : (ref1 = parsedToken.accessToken) === null || ref1 === void 0 ? void 0 : ref1.expiry) || 0;
    var refreshToken = (parsedToken === null || parsedToken === void 0 ? void 0 : (ref2 = parsedToken.refresh) === null || ref2 === void 0 ? void 0 : ref2.token) || "";
    var refreshTokenExpiry = (parsedToken === null || parsedToken === void 0 ? void 0 : (ref3 = parsedToken.refresh) === null || ref3 === void 0 ? void 0 : ref3.expiry) || 0;
    return {
        accessToken: accessToken,
        accessTokenExpiry: accessTokenExpiry,
        refreshToken: refreshToken,
        refreshTokenExpiry: refreshTokenExpiry
    };
};
var refreshExodusToken = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var ref, parsedToken, refreshToken, response, _data, newAccessTokenData, parsedAccessExpired, parsedRefreshExpired;
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    ;
                    parsedToken = utils_auth__WEBPACK_IMPORTED_MODULE_2__/* ["default"].getToken */ .Z.getToken();
                    refreshToken = parsedToken === null || parsedToken === void 0 ? void 0 : (ref = parsedToken.refresh) === null || ref === void 0 ? void 0 : ref.token;
                    _ctx.next = 5;
                    return axios__WEBPACK_IMPORTED_MODULE_1___default().post("".concat(constants_api__WEBPACK_IMPORTED_MODULE_3__/* .API_EXODUS_URL */ .q7, "/login/refresh"), null, {
                        headers: {
                            Authorization: "Bearer ".concat(refreshToken)
                        }
                    });
                case 5:
                    response = _ctx.sent;
                    if (!(!response || !response.data || !response.data.data)) {
                        _ctx.next = 8;
                        break;
                    }
                    throw new Error("Failed Refresh Token");
                case 8:
                    _data = response.data, newAccessTokenData = _data.data;
                    parsedAccessExpired = new Date(newAccessTokenData.access.expired_at).getTime();
                    parsedRefreshExpired = new Date(newAccessTokenData.refresh.expired_at).getTime();
                    utils_auth__WEBPACK_IMPORTED_MODULE_2__/* ["default"].saveToken */ .Z.saveToken({
                        accessToken: newAccessTokenData.access.token,
                        accessTokenExp: parsedAccessExpired,
                        refreshToken: newAccessTokenData.refresh.token,
                        refreshTokenExp: parsedRefreshExpired,
                        accessUser: utils_auth__WEBPACK_IMPORTED_MODULE_2__/* ["default"].getUserAccess */ .Z.getUserAccess()
                    });
                    return _ctx.abrupt("return", newAccessTokenData.access.token);
                case 13:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function refreshExodusToken() {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 68425:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ config_requestExodus; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
// EXTERNAL MODULE: ./src/constants/api.js
var api = __webpack_require__(37213);
// EXTERNAL MODULE: ./src/constants/app.js
var app = __webpack_require__(86123);
// EXTERNAL MODULE: ./src/constants/errorMessage.js
var errorMessage = __webpack_require__(61608);
// EXTERNAL MODULE: ./src/global/AlertErrorMessage/index.js + 1 modules
var AlertErrorMessage = __webpack_require__(25516);
// EXTERNAL MODULE: ./src/utils/auth.js
var auth = __webpack_require__(14229);
// EXTERNAL MODULE: ./src/utils/logger.ts
var logger = __webpack_require__(91635);
;// CONCATENATED MODULE: ./src/config/refreshToken/index.ts
/* eslint-disable no-param-reassign */ 

var generateNewRequestWithRefreshToken = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
        var apiInstance, axiosError, getRefreshTokenConfig, getAccessTokenData, refreshTokenPromise, refreshTokenConfig, dateNow, newAccessToken, newRequest;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    apiInstance = param.apiInstance, axiosError = param.axiosError, getRefreshTokenConfig = param.getRefreshTokenConfig, getAccessTokenData = param.getAccessTokenData, refreshTokenPromise = param.refreshTokenPromise;
                    refreshTokenConfig = getRefreshTokenConfig();
                    dateNow = Math.floor(Date.now() / 1000);
                    _ctx.prev = 3;
                    if (!(dateNow > getAccessTokenData().refreshTokenExpiry)) {
                        _ctx.next = 6;
                        break;
                    }
                    throw new Error("Failed Refresh Token");
                case 6:
                    if (!(typeof refreshTokenConfig === "undefined" || // Previous success refresh token config need to reset
                    (refreshTokenConfig.refreshingTokenStatus === "success" && dateNow > getAccessTokenData().accessTokenExpiry))) {
                        _ctx.next = 8;
                        break;
                    }
                    return _ctx.abrupt("return", generateNewRequestWithRefreshToken({
                        apiInstance: apiInstance,
                        axiosError: axiosError,
                        getAccessTokenData: getAccessTokenData,
                        refreshTokenPromise: refreshTokenPromise,
                        getRefreshTokenConfig: function() {
                            return getRefreshTokenConfig(true);
                        }
                    }));
                case 8:
                    if (!(refreshTokenConfig.refreshingTokenStatus === "initial")) {
                        _ctx.next = 15;
                        break;
                    }
                    refreshTokenConfig.refreshingTokenStatus = "processing";
                    _ctx.next = 12;
                    return refreshTokenPromise();
                case 12:
                    newAccessToken = _ctx.sent;
                    refreshTokenConfig.refreshingTokenStatus = "success";
                    // After refresh token API call success,
                    // proceed every API call within queue
                    refreshTokenConfig.refreshAndRetryQueue.forEach(function() {
                        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
                            var config, resolve, reject, newRequest;
                            return runtime_default().wrap(function _callee$(_ctx) {
                                while(1)switch(_ctx.prev = _ctx.next){
                                    case 0:
                                        config = param.config, resolve = param.resolve, reject = param.reject;
                                        config.headers.Authorization = "Bearer ".concat(newAccessToken);
                                        _ctx.prev = 2;
                                        _ctx.next = 5;
                                        return apiInstance.request(config);
                                    case 5:
                                        newRequest = _ctx.sent;
                                        resolve(newRequest);
                                        _ctx.next = 13;
                                        break;
                                    case 9:
                                        _ctx.prev = 9;
                                        _ctx.t0 = _ctx["catch"](2);
                                        refreshTokenConfig.refreshingTokenStatus = "failed";
                                        reject(_ctx.t0);
                                    case 13:
                                        _ctx.prev = 13;
                                        refreshTokenConfig.refreshAndRetryQueue = [];
                                        return _ctx.finish(13);
                                    case 16:
                                    case "end":
                                        return _ctx.stop();
                                }
                            }, _callee, null, [
                                [
                                    2,
                                    9,
                                    13,
                                    16
                                ]
                            ]);
                        }));
                        return function(_) {
                            return _ref.apply(this, arguments);
                        };
                    }());
                case 15:
                    if (!(refreshTokenConfig.refreshingTokenStatus === "success")) {
                        _ctx.next = 23;
                        break;
                    }
                    if (!(axiosError.config.headers.Authorization === "Bearer ".concat(getAccessTokenData().accessToken))) {
                        _ctx.next = 18;
                        break;
                    }
                    throw new Error("Token Alreadry Refreshed");
                case 18:
                    // Proceed new incoming API call with new API token
                    axiosError.config.headers.Authorization = "Bearer ".concat(getAccessTokenData().accessToken);
                    _ctx.next = 21;
                    return apiInstance.request(axiosError.config);
                case 21:
                    newRequest = _ctx.sent;
                    return _ctx.abrupt("return", newRequest);
                case 23:
                    _ctx.next = 29;
                    break;
                case 25:
                    _ctx.prev = 25;
                    _ctx.t0 = _ctx["catch"](3);
                    if (typeof refreshTokenConfig !== "undefined") {
                        refreshTokenConfig.refreshingTokenStatus = "failed";
                        refreshTokenConfig.refreshAndRetryQueue = [];
                    }
                    return _ctx.abrupt("return", Promise.reject(_ctx.t0));
                case 29:
                    return _ctx.abrupt("return", new Promise(function(resolve, reject) {
                        getRefreshTokenConfig().refreshAndRetryQueue.push({
                            config: axiosError.config,
                            resolve: resolve,
                            reject: reject
                        });
                    }));
                case 30:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                3,
                25
            ]
        ]);
    }));
    return function generateNewRequestWithRefreshToken(_) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ var refreshToken = (generateNewRequestWithRefreshToken);

// EXTERNAL MODULE: ./src/config/refreshToken/exodus.ts
var exodus = __webpack_require__(14350);
// EXTERNAL MODULE: ./src/config/APIErrorMessage/utils.ts
var utils = __webpack_require__(63858);
// EXTERNAL MODULE: ./src/config/APIErrorMessage/index.js + 1 modules
var APIErrorMessage = __webpack_require__(60714);
;// CONCATENATED MODULE: ./src/config/requestExodus.ts















var APIExodusErrorHandler = APIErrorMessage/* default.APIExodusErrorHandler */.Z.APIExodusErrorHandler;
function requestExodus() {
    var isShowAlertMessage = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true, context = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, customUserAgent = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, extraHeaders = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    var headers = (0,_object_spread/* default */.Z)({
        Accept: "application/json"
    }, extraHeaders);
    if (customUserAgent) {
        headers = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, headers), {
            "User-Agent": api/* CUSTOM_USER_AGENT */.GV
        });
    }
    var apiInstance = axios_default().create({
        baseURL: api/* API_EXODUS_URL */.q7,
        headers: headers
    });
    apiInstance.interceptors.request.use(function(request) {
        var ref, ref1;
        var requestFromBrowser = (0,app/* isClient */.C5)();
        if (!requestFromBrowser) {
            return request;
        }
        if (!(window === null || window === void 0 ? void 0 : (ref = window.navigator) === null || ref === void 0 ? void 0 : ref.onLine)) {
            (0,AlertErrorMessage/* default */.Z)(errorMessage/* default.OFFLINE */.Z.OFFLINE, errorMessage/* default.ALERT_RED */.Z.ALERT_RED);
            return Promise.reject(errorMessage/* default.OFFLINE */.Z.OFFLINE);
        }
        // Custom Authorization Header Exist
        if (request.headers.Authorization) {
            return request;
        }
        // Default Authorization
        var parsedToken = auth/* default.getToken */.Z.getToken();
        var token = parsedToken === null || parsedToken === void 0 ? void 0 : (ref1 = parsedToken.accessToken) === null || ref1 === void 0 ? void 0 : ref1.token;
        if (request.url !== "/user/setting/password/reset" && token) {
            // eslint-disable-next-line no-param-reassign
            request.headers.Authorization = "Bearer ".concat(token);
        }
        return request;
    }, function(error) {
        return Promise.reject(error);
    });
    apiInstance.interceptors.response.use(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(response) {
            var responseRetrieveFromBrowser, _data, errorType, _message, message;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        responseRetrieveFromBrowser = (0,app/* isClient */.C5)();
                        if (responseRetrieveFromBrowser) {
                            _ctx.next = 3;
                            break;
                        }
                        return _ctx.abrupt("return", response);
                    case 3:
                        _data = response.data, errorType = _data.error_type, _message = _data.message, message = _message === void 0 ? errorMessage/* default.DEFAULT_ERROR_MESSAGE */.Z.DEFAULT_ERROR_MESSAGE : _message;
                        if (!(errorType && isShowAlertMessage)) {
                            _ctx.next = 7;
                            break;
                        }
                        (0,AlertErrorMessage/* default */.Z)(message, errorMessage/* default.ALERT_RED */.Z.ALERT_RED);
                        throw message;
                    case 7:
                        return _ctx.abrupt("return", response);
                    case 8:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(response) {
            return _ref.apply(this, arguments);
        };
    }(), function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(axiosError) {
            var ref, ref1, ref2, ref3, responseRetrieveFromBrowser, newRequest, _response, status, data, message, errorType, parsedMessage;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        responseRetrieveFromBrowser = (0,app/* isClient */.C5)();
                        if (responseRetrieveFromBrowser) {
                            _ctx.next = 4;
                            break;
                        }
                        return _ctx.abrupt("return", Promise.reject(axiosError));
                    case 4:
                        if (axiosError === null || axiosError === void 0 ? void 0 : axiosError.response) {
                            _ctx.next = 6;
                            break;
                        }
                        return _ctx.abrupt("return", Promise.reject(axiosError));
                    case 6:
                        //-------------------------------------------
                        // Error Logger
                        (0,logger/* sentryLog */.gB)({
                            scope: "server-layer",
                            level: "error",
                            httpStatusCode: (ref = axiosError.response) === null || ref === void 0 ? void 0 : ref.status,
                            tags: [
                                {
                                    title: "api-error-url",
                                    value: axiosError === null || axiosError === void 0 ? void 0 : (ref1 = axiosError.request) === null || ref1 === void 0 ? void 0 : ref1.responseURL
                                },
                                {
                                    title: "api-error-text",
                                    value: axiosError === null || axiosError === void 0 ? void 0 : (ref2 = axiosError.request) === null || ref2 === void 0 ? void 0 : ref2.responseText
                                }, 
                            ],
                            error: new Error(axiosError.message)
                        });
                        if (![
                            401
                        ].includes((ref3 = axiosError.response) === null || ref3 === void 0 ? void 0 : ref3.status)) {
                            _ctx.next = 19;
                            break;
                        }
                        _ctx.prev = 8;
                        _ctx.next = 11;
                        return refreshToken({
                            apiInstance: apiInstance,
                            axiosError: axiosError,
                            getRefreshTokenConfig: exodus/* getRefreshTokenConfigFn */.oD,
                            getAccessTokenData: exodus/* getAccessTokenDataFn */.RL,
                            refreshTokenPromise: exodus/* refreshExodusToken */.x5
                        });
                    case 11:
                        newRequest = _ctx.sent;
                        return _ctx.abrupt("return", newRequest);
                    case 15:
                        _ctx.prev = 15;
                        _ctx.t0 = _ctx["catch"](8);
                        (0,utils/* dispatchSetErrorCode */.S)(401);
                        return _ctx.abrupt("return", Promise.reject(_ctx.t0));
                    case 19:
                        _response = axiosError.response, status = _response.status, data = _response.data;
                        message = data === null || data === void 0 ? void 0 : data.message;
                        errorType = data === null || data === void 0 ? void 0 : data.error_type;
                        // Some error message is unparsed in `message`
                        if (!errorType) {
                            parsedMessage = JSON.parse(message);
                            message = parsedMessage.message;
                            errorType = parsedMessage.error_type;
                        }
                        if (isShowAlertMessage) {
                            _ctx.next = 25;
                            break;
                        }
                        return _ctx.abrupt("return", Promise.reject(axiosError));
                    case 25:
                        APIExodusErrorHandler(status, errorType, message);
                        return _ctx.abrupt("return", Promise.reject(axiosError));
                    case 27:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    8,
                    15
                ]
            ]);
        //-------------------------------------------
        }));
        return function(axiosError) {
            return _ref.apply(this, arguments);
        };
    }());
    return apiInstance;
}
/* harmony default export */ var config_requestExodus = (requestExodus);


/***/ }),

/***/ 37213:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BW": function() { return /* binding */ STOCKBIT_ACADEMY_URL; },
/* harmony export */   "CT": function() { return /* binding */ API_BASE_URL; },
/* harmony export */   "Cb": function() { return /* binding */ API_TRADING_URL; },
/* harmony export */   "GV": function() { return /* binding */ CUSTOM_USER_AGENT; },
/* harmony export */   "J3": function() { return /* binding */ GIPHY_STICKERS_URL; },
/* harmony export */   "Me": function() { return /* binding */ AWS_IMAGES_BUCKET; },
/* harmony export */   "UY": function() { return /* binding */ GIPHY_API_KEY; },
/* harmony export */   "VE": function() { return /* binding */ GOOGLE_PLAY_URL; },
/* harmony export */   "ZB": function() { return /* binding */ API_CURATOR_URL; },
/* harmony export */   "_O": function() { return /* binding */ SITE_URL; },
/* harmony export */   "cU": function() { return /* binding */ AWS_AVATAR_BUCKET; },
/* harmony export */   "cu": function() { return /* binding */ API_TRADING_URL_V2; },
/* harmony export */   "fN": function() { return /* binding */ GIPHY_URL; },
/* harmony export */   "jd": function() { return /* binding */ CURATOR_FEED_ID; },
/* harmony export */   "kg": function() { return /* binding */ API_SECURITIES_GENERAL_URL; },
/* harmony export */   "l5": function() { return /* binding */ APP_STORE_URL; },
/* harmony export */   "lZ": function() { return /* binding */ FACEBOOK_APP_ID; },
/* harmony export */   "q$": function() { return /* binding */ AVATAR_URL; },
/* harmony export */   "q7": function() { return /* binding */ API_EXODUS_URL; },
/* harmony export */   "rM": function() { return /* binding */ AWS_EBOOK_BUCKET; },
/* harmony export */   "uJ": function() { return /* binding */ GOPAY_URL_JAVASCRIPT; },
/* harmony export */   "vw": function() { return /* binding */ AWS_TRADE_REG_BUCKET; }
/* harmony export */ });
/* unused harmony exports STAGE, API_SECURITIES_ALT_URL, SOCKET_URL, AWS_CHAT_BUCKET, GOPAY_QR_CODE_URL, GOPAY_REF_ID_URL, API_VERSION_ALT, DESKTOP_APP_BUCKET, DESKTOP_APP_SECRET_KEY, DESKTOP_APP_ACCESS_KEY, DESKTOP_APP_URL, DESKTOP_APP_END_POINT, CURATOR_TOKEN, APPLE_APP_SITE_ID */
/* provided dependency */ var process = __webpack_require__(34155);
var STAGE = (/* unused pure expression or super */ null && ("production" || 0));
var SITE_URL = "https://stockbit.com" || 0;
var SOCKET_URL = (/* unused pure expression or super */ null && ("https://ws3.stockbit.com/"));
// Separate the version with base URL, if we need more version
// just add from `.env`, then add them into this file
var API_VERSION = "v2.5";
var API_VERSION_ALT = "v2.4" || 0;
var API_BASE_URL = "".concat("https://api.stockbit.com", "/").concat(API_VERSION);
var API_EXODUS_URL = "https://exodus.stockbit.com";
var API_TRADING_URL = "https://trading.masonline.id";
var API_TRADING_URL_V2 = "https://carina.stockbit.com";
var API_SECURITIES_ALT_URL = "".concat("https://api.stockbit.com", "/").concat(API_VERSION_ALT);
// Can be used with social or trading authorization
var API_SECURITIES_GENERAL_URL = "https://api-sekuritas.stockbit.com";
var API_CURATOR_URL = "https://api.curator.io";
var AVATAR_URL = "https://avatar.stockbit.com" || 0;
var AWS_AVATAR_BUCKET = "https://avatar.stockbit.com" || 0;
var AWS_IMAGES_BUCKET = "https://stockbit.s3.amazonaws.com";
var AWS_TRADE_REG_BUCKET = "https://simasreg.s3.amazonaws.com";
var AWS_EBOOK_BUCKET = "https://s3-ap-southeast-1.amazonaws.com/ebookstbx";
var AWS_CHAT_BUCKET = process.env.NEXT_PUBLIC_AWS_CHAT_BUCKET;
var GIPHY_URL = "https://api.giphy.com/v1/gifs";
var GIPHY_STICKERS_URL = "https://api.giphy.com/v1/stickers";
var GIPHY_API_KEY = "ZME7nTxOPIqXCf9qhCfqB1ICqtFCbCs5" || 0;
var GOPAY_URL_JAVASCRIPT = "https://app.midtrans.com/snap/snap.js" || 0;
var GOPAY_QR_CODE_URL = (/* unused pure expression or super */ null && ("https://api.sandbox.veritrans.co.id/v2/gopay/" || 0));
var GOPAY_REF_ID_URL = (/* unused pure expression or super */ null && ("https://simulator.sandbox.midtrans.com/gopay/ui/checkout?referenceid=" || 0));
var FACEBOOK_APP_ID = "247631672013136" || 0;
// link to download stockbit app
var GOOGLE_PLAY_URL = "https://play.google.com/store/apps/details?id=com.stockbit.android&hl=en";
var APP_STORE_URL = "https://itunes.apple.com/us/app/stockbit/id1184800207?mt=8";
var STOCKBIT_ACADEMY_URL = "https://academy.stockbit.com";
var CUSTOM_USER_AGENT = "webapp-api-293bf2f3-2d64-4948-94dd-9277ebbe96d";
var DESKTOP_APP_BUCKET = (/* unused pure expression or super */ null && ("sb-sda-release"));
var DESKTOP_APP_SECRET_KEY = (/* unused pure expression or super */ null && ("EFKHBWQHWq0jWNNGM2/e35vU4vOrN4OHyd4f09Kv"));
var DESKTOP_APP_ACCESS_KEY = (/* unused pure expression or super */ null && ("AKIAX4CD7C6D4DF5LTF6"));
var DESKTOP_APP_URL = (/* unused pure expression or super */ null && ("https://sda-release.stockbit.com/"));
var DESKTOP_APP_END_POINT = (/* unused pure expression or super */ null && ("https://s3.ap-southeast-3.amazonaws.com/"));
var CURATOR_TOKEN = (/* unused pure expression or super */ null && ("ae406fc1-d23a-4a34-a0c9-164c7d2204ea"));
var CURATOR_FEED_ID = "1e81f0c0-550d-492e-b3ae-0dd4706df21f";
var APPLE_APP_SITE_ID = (/* unused pure expression or super */ null && ("ASHUNREKRL.stockbit.com.stockbit"));



/***/ }),

/***/ 86123:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ax": function() { return /* binding */ GTM_ID; },
/* harmony export */   "C5": function() { return /* binding */ isClient; },
/* harmony export */   "Vc": function() { return /* binding */ assetPrefix; },
/* harmony export */   "cU": function() { return /* binding */ AWS_AVATAR_BUCKET; },
/* harmony export */   "d7": function() { return /* binding */ CLEVERTAP_ID; },
/* harmony export */   "mM": function() { return /* binding */ assetsStatic; },
/* harmony export */   "or": function() { return /* binding */ STAGE; },
/* harmony export */   "qV": function() { return /* binding */ PROJECT_FOLDER_PATH; },
/* harmony export */   "sP": function() { return /* binding */ PROJECT_FOLDER; },
/* harmony export */   "t0": function() { return /* binding */ CRISP_ID; },
/* harmony export */   "yv": function() { return /* binding */ isProduction; },
/* harmony export */   "yz": function() { return /* binding */ siteUrl; }
/* harmony export */ });
/* unused harmony exports CDN, R2_ASSET_PREFIX, FB_APP_ID, USER_AGENT, OPEN_HOUR, CLOSE_HOUR, isMarketOpen, STRUCTURED_DATA */
/* provided dependency */ var process = __webpack_require__(34155);
var PROJECT_FOLDER = process.env.NEXT_PUBLIC_PROJECT_FOLDER;
var PROJECT_FOLDER_PATH = PROJECT_FOLDER ? "/".concat(PROJECT_FOLDER) : "";
var CDN = "https://stockbit.com" || 0;
var assetPrefix = CDN ? "".concat(CDN).concat(PROJECT_FOLDER_PATH) : "";
var R2_ASSET_PREFIX = "https://web-assets.stockbit.com";
var FB_APP_ID = (/* unused pure expression or super */ null && ("247631672013136" || 0));
var GTM_ID = "GTM-5DQC6T3" || 0;
var siteUrl = "https://stockbit.com" || 0;
var STAGE = "production" || 0;
var CLEVERTAP_ID = "6ZW-897-5R6Z";
var AWS_AVATAR_BUCKET = "https://avatar.stockbit.com" || 0;
var USER_AGENT = (/* unused pure expression or super */ null && ("webapp-api-293bf2f3-2d64-4948-94dd-9277ebbe96d" || 0));
var CRISP_ID = "44ed90bf-ce78-4f5f-a9f8-82e000538b9b" || 0;
var isClient = function() {
    return "object" !== "undefined";
};
var isProduction = "production" === "production";
// Market hour
var OPEN_HOUR = 9;
var CLOSE_HOUR = 15;
var isMarketOpen = function() {
    var currentTime = new Date().getHours();
    // return currentTime >= OPEN_HOUR && currentTime <= CLOSE_HOUR;
    return currentTime >= OPEN_HOUR;
};
var STRUCTURED_DATA = {
    "@context": "http://schema.org",
    "@type": "Corporation",
    name: "Stockbit",
    legalName: "Stockbit",
    description: "Stockbit adalah komunitas investasi di Indonesia. Stockbit memberi ruang bagi investor dan trader untuk berbagi ide, berita dan informasi keuangan lainya secara real-time. Pengguna bisa membuat profil dan mengikuti saham tertentu atau investor favorit untuk mendapatkan informasi berharga dan bertukar pikiran. Fitur utama dari Stockbit yaitu 'stream' terdiri dari ide-ide, grafik saham, link dan data keuangan lainya. Stockbit menggunakan tanda '$' sebelum kode saham sebagai penandaan ide untuk mempermudah pengguna dalam mencari informasi tentang saham individu tertentu. Platform Stockbit juga terintegrasi dengan platform social media lainya, seperti Twitter dan Facebook, sehingga mudah untuk berbagi ide-ide di Stockbit ke akun Twitter dan Facebook pengguna. Stockbit dirancang dengan fitur yang terfokus dengan keperilakuan investor dan trader sehingga akan lebih berguna sebagai social media khusus investasi.",
    logo: "https://assets-nextjs.stockbit.com/img/favicon.ico",
    url: "https://stockbit.com",
    telephone: "+6221 57906242",
    sameAs: [
        "https://twitter.com/Stockbit",
        "https://www.linkedin.com/company/stockbit",
        "https://www.facebook.com/Stockbit",
        "https://www.youtube.com/c/Stockbit",
        "https://instagram.com/stockbit",
        "https://www.crunchbase.com/organization/stockbit", 
    ],
    address: {
        "@type": "PostalAddress",
        streetAddress: "RDTX Square 33rd Floor, Jl. Prof. Dr. Satrio No 164 - Jakarta",
        addressLocality: "Jakarta Selatan",
        postalCode: "12930",
        addressCountry: "Indonesia"
    }
};
var assetsStatic = "".concat("https://assets.stockbit.com");


/***/ }),

/***/ 70524:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var RUNNING_TRADE = {
    SEARCH_INPUT: "running-trade-search-input",
    SEARCH_INPUT_CLEAR_BUTTON: "running-trade-search-input-clear-button"
};
var CALENDAR = {
    HEADER_MORE_BUTTON: "calendar-header-more-button",
    ROW_SYMBOL: "calendar-row-symbol"
};
var PROFILE = {
    HEADER_MORE_BUTTON: "profile-header-more-button",
    HEADER_BLOCK_BUTTON: "profile-header-block-button"
};
var CHATROOM = {
    GROUP_MEMBER: "chatroom-group-member",
    SEND_MESSAGE_BUTTON: "chatroom-send-message-button",
    CONFIRM_DELETE_MESSAGE_BUTTON: "chatroom-confirm-delete-message-button",
    CAPSULE_USER_NEW_GROUP: "chatroom-capsule-user-new-group",
    CAPSULE_USER_NEW_GROUP_CLOSE: "chatroom-capsule-user-new-group-close",
    SUGGESTED_USER: "chatroom-suggested-user"
};
var COMPANY = {
    NAVBAR_MORE_MENU: "company-navbar-more-menu",
    WIDGET_CATALOG: "company-widget-catalog",
    WIDGET_CATALOG_ITEM: "company-widget-catalog-item",
    WIDGET_INVESTMENT_MORE_BUTTON: "company-widget-investment-more-button"
};
var NOTIFICATION = {
    TITLE_TEXT: "notification-title-text"
};
var VALUATION = {
    HEADER_TITLE: "valuation-header-title",
    HEADER_MORE_BUTTON: "valuation-header-more-button"
};
var NAVIGATION = {
    MORE_MENU_BUTTON: "navigation-more-menu-button"
};
var GLOSSARY = {
    SEARCH_SUGGESTION: "glossary-search-suggestion"
};
var SHARE_POST = {
    CHECKBOX: "share-post-checkbox",
    SEND_BUTTON: "share-post-send-button"
};
var STREAM_POST = {
    CONFIRM_DELETE_BUTTON: "stream-post-confirm-delete-button",
    CONFIRM_CANCEL_BUTTON: "stream-post-confirm-cancel-button"
};
var EARNINGS = {
    SEARCH_SYMBOL_INPUT: "earnings-search-symbol-input",
    SEARCH_SYMBOL_BUTTON: "earnings-search-symbol-button",
    TABLE_ROW_SYMBOL: "earnings-table-row-symbol"
};
var FINANCIALS = {
    TABLE_TITLE_TEXT: "financials-table-title-text",
    TABLE_QUARTER_TEXT: "financials-table-quarter-text",
    TABLE_INCOME_TEXT: "financials-table-income-text"
};
var SCREENER = {
    DELETE_RULES_BUTTON: "screener-delete-rules-button",
    CLOSE_POPUP_BUTTON: "screener-close-popup-button",
    STOCK_SEARCH_INPUT: "screener-stock-search-input"
};
var LANDING = {
    REGISTER_BUTTON: "landing-register-button",
    LOGIN_BUTTON: "landing-login-button"
};
/* harmony default export */ __webpack_exports__["Z"] = ({
    RUNNING_TRADE: RUNNING_TRADE,
    CALENDAR: CALENDAR,
    PROFILE: PROFILE,
    CHATROOM: CHATROOM,
    COMPANY: COMPANY,
    NOTIFICATION: NOTIFICATION,
    VALUATION: VALUATION,
    NAVIGATION: NAVIGATION,
    GLOSSARY: GLOSSARY,
    SHARE_POST: SHARE_POST,
    STREAM_POST: STREAM_POST,
    EARNINGS: EARNINGS,
    FINANCIALS: FINANCIALS,
    SCREENER: SCREENER,
    LANDING: LANDING
});


/***/ }),

/***/ 61608:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var ERROR_MESSAGE = {
    ALERT_RED: "alert-red",
    DEFAULT: "DEFAULT",
    MAINTENANCE: "MAINTENANCE",
    NOPERMISSION: "NOPERMISSION",
    NOTRADINGPERMISSION: "NOTRADINGPERMISSION",
    INVALIDPARAMETER: "INVALIDPARAMETER",
    INVALID_PARAMETER: "INVALID_PARAMETER",
    INVALID_LOGIN: "INVALID_LOGIN",
    ERR_SYSTEM: "ERR_SYSTEM",
    ERR_INVALID_PARAMS: "ERR_INVALID_PARAMS",
    ERR_ORDER_FAIL: "ERR_ORDER_FAIL",
    ERR_PIN_INVALID: "ERR_PIN_INVALID",
    ERR_LOGIN_FAIL: "ERR_LOGIN_FAIL",
    INVALID_AMEND: "INVALID_AMEND",
    INVALID_PIN: "INVALID_PIN",
    SYSTEMERROR: "SYSTEMERROR",
    NOTFOUND: "NOTFOUND",
    NOSUBSCRIPTION: "NOSUBSCRIPTION",
    PAYWALL_ERROR: "PAYWALL",
    PAYWALL_NOSUBSCRIPTION: "NO_SUBSCRIPTION",
    NOPHONEVERIFY: "NOPHONEVERIFY",
    UNAUTHORIZED: "UNAUTHORIZED",
    FORBIDDEN: "FORBIDDEN",
    SERVICE_BUSY: "SERVICE_BUSY",
    INVALID_SESSION: "INVALID_SESSION",
    ERR_LOGIN_AUTHORIZATION: "ERR_LOGIN_AUTHORIZATION",
    ERR_PIN_AUTHORIZATION: "ERR_PIN_AUTHORIZATION",
    ERR_UNKNOWN_BROKER: "ERR_UNKNOWN_BROKER",
    INCORRECT_PIN: "INCORRECT_PIN",
    INVALID_CREDS: "INVALID_CREDS",
    UNKNOWN_SYSTEM_ERROR: "Kondisi Internet Kamu Sedang Tidak Stabil.",
    OFFLINE: "Kondisi internet kamu sedang tidak stabil",
    DEFAULT_ERROR_MESSAGE: "Something is terribly wrong, please contact our administrator",
    PERMISSION_DENIED: "You do not have enough permission to access the resources",
    // error message upload avatar onboarding
    UPLOAD_FAILED: "Upload Failed",
    PLEASE_LOAD_IMAGE: "Please load an image",
    UPLOAD_IMAGE_TYPE_NOT_SUPPORTED: "Only image file (type: JPEG, JPG, PNG, and GIF) allowed",
    UPLOAD_DOCUMENT_TYPE_NOT_SUPPORTED: "Only document file (type: PDF, DOC, DOCX, PPT, PPTX, XLS and XLSX) allowed",
    MAX_FILE_SIZE: "Max File Size 2Mb",
    INVALID_AVATAR_EXTENSION: "Only image file (type: JPEG, JPG, and PNG) allowed",
    // stream error message
    DOCUMENT_IMAGE_NOT_ALLOWED: 'Image files (such as jpg, jpeg, png, gif) are not allowed to be uploaded from "Attach Document" input',
    MAX_UPLOAD_FILES: "Maximum of 1 file uploads allowed",
    STREAM_TEXT_REQUIRED: "Text is required in posts",
    STREAM_TARGET_PRICE_REQUIRED: "Target Price is required in posts",
    STREAM_ERROR_UPLOAD_FILE: "Upload file error",
    ACADEMY_ERROR_MESSAGE: "Failed to open Academy, Please reload this page",
    // Screener
    SCREENER_SPECIFY_RULES: "Please enter at least one screening rule",
    SCREENER_SPECIFY_RULES_VALUE: "Please enter a value on your screening rule",
    // Tipping
    TIPPING_MAX_AMOUNT_ERROR: "Jumlah Maksimal Tip Rp 10,000,000",
    // Fundachart
    MAX_METRICES_AND_SYMBOLS: "Harap pilih tidak lebih dari total 10 parameter (perusahaan/metrik) untuk bagan",
    // Chartbit
    LOAD_TEMPLATE: "Failed to load template",
    SAVE_TEMPLATE: "Failed to save template"
};
/* harmony default export */ __webpack_exports__["Z"] = (ERROR_MESSAGE);


/***/ }),

/***/ 44252:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BP": function() { return /* binding */ REGISTRATION_DATA; },
/* harmony export */   "Nv": function() { return /* binding */ REFRESH_TOKEN_KEY_EXP; },
/* harmony export */   "Wx": function() { return /* binding */ ACCESS_TOKEN_KEY; },
/* harmony export */   "ns": function() { return /* binding */ ACCESS_USER_KEY; },
/* harmony export */   "w4": function() { return /* binding */ REFRESH_TOKEN_KEY; },
/* harmony export */   "z0": function() { return /* binding */ ACCESS_TOKEN_KEY_EXP; }
/* harmony export */ });
var ACCESS_TOKEN_KEY = "at";
var ACCESS_TOKEN_KEY_EXP = "ate";
var REFRESH_TOKEN_KEY = "ar";
var REFRESH_TOKEN_KEY_EXP = "are";
var ACCESS_USER_KEY = "au";
var REGISTRATION_DATA = "registerData";


/***/ }),

/***/ 41208:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var SUCCESS_MESSAGE = {
    ALERT_GREEN: "alert-green",
    SNACKBAR_GREEN: "snackbar-green",
    PROFILE_UPDATED: "Profile Updated",
    POST_SUCCESSFUL: "Post successful",
    REPOST_SUCCESSFUL: "Post Reposted",
    REPLY_SUCCESSFUL: "Post reply successful!",
    SET_TOP_SUCCESSFUL: "Set as Top successful!",
    REMOVE_TOP_SUCCESSFUL: "Remove as Top successful!",
    RESET_TOP_SUCCESSFUL: "Reset as Top successful!",
    UNTAG_POST_SUCCESSFUL: "Untag Post Topic Success",
    PASSWORD_CHANGED: "Password changed",
    USER_BLOCKED: "User blocked",
    USER_UNBLOCKED: "User unblocked",
    CHANGE_NUMBER_SUCCESSFUL: "Phone number changed!",
    SAVE_TEMPLATE_SUCCESS: "Success save template",
    POST_SHARED_SUCCESSFUL: "Post Shared",
    EVENT_SHARED_SUCCESSFUL: "Event Shared",
    POST_PINNED_SUCCESSFUL: "Post successfully pinned",
    POST_UNPINNED_SUCCESSFUL: "Post successfully unpinned",
    POST_SUCCESSFUL_UPDATE: "Post successfully updated",
    POST_SUCCESSFUL_DELETED: "Successfully deleted",
    SCREENER_TEMPLATE_DELETED: "Screener Template Deleted",
    FACEBOOK_CONNECTED: "Facebook connect successful",
    GOPAY_CHANGED: "Nomor gopay anda berhasil diubah",
    REPORT_DELIVERED: "Report has been delivered",
    UPDATE_GROUP_PHOTO_SUCCESSFUL: "Group Photo Updated",
    DELETE_STREAM_MULTIPLE_SUCCESSFUL: "Success delete stream",
    FINANCIAL_COLUMN_DELETED: "Financial Column Deleted"
};
/* harmony default export */ __webpack_exports__["Z"] = (SUCCESS_MESSAGE);


/***/ }),

/***/ 51346:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ku": function() { return /* binding */ localStorageOrderbookHandler; },
/* harmony export */   "M6": function() { return /* binding */ transformNewOrderbookListToExisting; },
/* harmony export */   "g8": function() { return /* binding */ memoizeChild; }
/* harmony export */ });
/* unused harmony export getErrorMessage */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


var localStorageOrderbookHandler = {
    get: function() {
        var orderbookName = localStorage.getItem("orderbooklistName");
        var orderbookID = localStorage.getItem("orderbooklistID");
        return {
            orderbookName: orderbookName,
            orderbookID: orderbookID
        };
    },
    set: function(orderbookName, orderbookID) {
        localStorage.setItem("orderbooklistID", orderbookID);
        localStorage.setItem("orderbooklistName", orderbookName);
    },
    remove: function() {
        localStorage.removeItem("orderbooklistID");
        localStorage.removeItem("orderbooklistName");
    }
};
var getErrorMessage = function(error) {
    var ref, ref1;
    var err = _instanceof(error, Error) ? (error === null || error === void 0 ? void 0 : (ref = error.response) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.error) || error.message : String(error);
    return err;
};
var memoizeChild = function(component) {
    var circular = function() {
        var seen = new WeakSet();
        return function(key, value) {
            if (key.startsWith("_")) return; // Don't compare React's internal props.
            if (typeof value === "object" && value !== null) {
                if (seen.has(value)) return;
                seen.add(value);
            }
            return value;
        };
    };
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.memo)(component, function(prevProps, nextProps) {
        var prev = JSON.stringify(prevProps, circular());
        var next = JSON.stringify(nextProps, circular());
        return prev === next;
    });
};
var transformNewOrderbookListToExisting = function(newResponse) {
    var tradeable = newResponse.tradable ? 1 : 0;
    var bidObject = {};
    var offerObject = {};
    newResponse.bid.forEach(function(value, index) {
        var priceNameKey = "price".concat(index + 1);
        bidObject[priceNameKey] = value.price;
        var queNumNameKey = "que_num".concat(index + 1);
        bidObject[queNumNameKey] = value.que_num;
        var valueNameKey = "volume".concat(index + 1);
        bidObject[valueNameKey] = value.volume;
    });
    newResponse.offer.forEach(function(value, index) {
        var priceNameKey = "price".concat(index + 1);
        offerObject[priceNameKey] = value.price;
        var queNumNameKey = "que_num".concat(index + 1);
        offerObject[queNumNameKey] = value.que_num;
        var valueNameKey = "volume".concat(index + 1);
        offerObject[valueNameKey] = value.volume;
    });
    return {
        id: newResponse.id,
        symbol: newResponse.symbol,
        symbol_2: newResponse.symbol,
        symbol_3: newResponse.symbol,
        name: newResponse.name,
        status: newResponse.status,
        lastprice: newResponse.lastprice,
        previous: newResponse.previous,
        change: newResponse.change,
        percentage_change: newResponse.percentage_change,
        open: newResponse.open,
        high: newResponse.high,
        low: newResponse.low,
        close: newResponse.close,
        volume: newResponse.volume,
        value: newResponse.value,
        average: newResponse.average,
        bid: bidObject,
        offer: offerObject,
        frequency: newResponse.frequency,
        fbuy: newResponse.fbuy,
        fsell: newResponse.fsell,
        fnet: newResponse.fnet,
        fpercent: newResponse.fpercent,
        tradeable: tradeable,
        notation: newResponse.notation,
        uma: newResponse.uma,
        GUID: null,
        is_foreignbs_exist: newResponse.has_foreign_bs,
        exchange: newResponse.exchange,
        country: null,
        foreign: null,
        domestic: null,
        up: null,
        down: null,
        unchanged: null,
        iepiev: newResponse.iepiev,
        ara: newResponse.ara,
        arb: newResponse.arb,
        company_type: newResponse.company_type,
        corp_action: newResponse.corp_action,
        market_data: newResponse.market_data
    };
};


/***/ }),

/***/ 25516:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ AlertErrorMessage; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/antd/es/message/index.js + 1 modules
var message = __webpack_require__(12461);
// EXTERNAL MODULE: ./node_modules/@stockbit/ui/index.js
var ui = __webpack_require__(76825);
// EXTERNAL MODULE: ./src/constants/app.js
var app = __webpack_require__(86123);
// EXTERNAL MODULE: ./src/global/Image/index.js
var Image = __webpack_require__(579);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
;// CONCATENATED MODULE: ./src/global/AlertErrorMessage/styled.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  border-radius: 50%;\n  margin-right: 10px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var UIIconWrapper = ui/* Common.IconWrapper */.Gn.IconWrapper;
var IconWrapper = (0,styled_components_browser_esm["default"])(UIIconWrapper).withConfig({
    componentId: "sc-2b178c34-0"
})(_templateObject(), ui/* color.primary */.$_.primary);
// eslint-disable-next-line import/prefer-default-export


;// CONCATENATED MODULE: ./src/global/AlertErrorMessage/index.js
/* eslint-disable max-len */ // ant design






var Iconmoon = ui/* Common.Iconmoon */.Gn.Iconmoon, Flex = ui/* Common.Flex */.Gn.Flex;
/**
 * handleErrorMessageAPI to activate message
 * @param {string} content
 * @param {string} type - "alert-green" | "alert-red" | "alert-orange" | "alert-blue" | "snackbar-green" | "plain-green"
 * @param {=boolean} hasCloseIcon
 */ var handleErrorMessageAPI = function(content, type) {
    var hasCloseIcon = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    if (!(0,app/* isClient */.C5)()) return null;
    // destroy last message alert
    message/* default.destroy */.ZP.destroy();
    var Icon = null;
    var closeIcon = hasCloseIcon ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
        src: "/icon/alert-close.svg",
        onClick: function() {
            return message/* default.destroy */.ZP.destroy();
        }
    }) : null;
    if (type === "alert-green") {
        Icon = /*#__PURE__*/ (0,jsx_runtime.jsx)(IconWrapper, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconmoon, {
                size: "14px",
                className: "icon-toolbar_check",
                color: ui/* color.light */.$_.light
            })
        });
    } else if (type === "snackbar-green") {
        Icon = /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
            src: "/icon/alert-success.svg"
        });
    }
    // show alert
    message/* default.open */.ZP.open({
        content: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: type,
            "data-cy": "global-alert-message",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex, {
                align: "center",
                children: [
                    Icon,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: content
                    }),
                    closeIcon
                ]
            })
        }),
        duration: 3,
        style: {
            top: "50px",
            fontFamily: "ProximaNovaRg",
            left: 0,
            margin: "auto",
            position: "fixed",
            right: 0,
            maxWidth: "320px"
        },
        className: "sysmsg-content",
        onClick: function() {
            return message/* default.destroy */.ZP.destroy();
        }
    });
};
/* harmony default export */ var AlertErrorMessage = (handleErrorMessageAPI);


/***/ }),

/***/ 29658:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var If = function(param) {
    var children = param.children, condition = param.condition;
    if (!condition) {
        return null;
    }
    // render children if the condition is truthy
    return children;
};
/* harmony default export */ __webpack_exports__["Z"] = (If); /**
 * https://www.stefanjudis.com/snippets/a-react-if-component/
 *
 * Use the component as follows:
 *
 * <IF condition={condition}>
 *   <Greeter username={user.name} />
 * </IF>
 */ 


/***/ }),

/***/ 579:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var constants_app__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86123);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);





var Image = function(_param) {
    var src = _param.src, _alt = _param.alt, alt = _alt === void 0 ? "" : _alt, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "src",
        "alt"
    ]);
    var source = src || "";
    var isBlob = source.startsWith("blob:");
    var isBase64 = source.startsWith("data:");
    var isUrl = source.startsWith("http") || source.startsWith("//");
    if (source && !isUrl && !isBlob && !isBase64) {
        var separator = source.startsWith("/") ? "" : "/";
        source = "".concat(constants_app__WEBPACK_IMPORTED_MODULE_1__/* .assetPrefix */ .Vc).concat(separator).concat(source);
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        src: source,
        alt: alt
    }, rest));
};
Image.defaultProps = {
    alt: ""
};
Image.propTypes = {
    src: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string.isRequired),
    alt: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string)
};
/* harmony default export */ __webpack_exports__["Z"] = (Image);


/***/ }),

/***/ 598:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Loading_PageLoader; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@stockbit/ui/index.js
var ui = __webpack_require__(76825);
// EXTERNAL MODULE: ./src/global/ErrorHandlers/If.js
var If = __webpack_require__(29658);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
;// CONCATENATED MODULE: ./src/global/Loading/styled.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      opacity: 0;\n      visibility: hidden;\n      z-index: 1;\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  background: white;\n  display: flex;\n  height: 100%;\n  justify-content: center;\n  left: 0;\n  opacity: 1;\n  position: fixed;\n  top: 0;\n  transition: all 0.3s ease-in-out;\n  visibility: visible;\n  width: 100%;\n  z-index: 1050;\n\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 16px;\n  height: 16px;\n  background-color: #333;\n  margin: 0 5px;\n  border-radius: 100%;\n  display: inline-block;\n  -webkit-animation: sk-bouncedelay 1.4s infinite ease-in-out both;\n  animation: sk-bouncedelay 1.4s infinite ease-in-out both;\n  transform-origin: center center;\n\n  &:first-child {\n    -webkit-animation-delay: -0.32s;\n    animation-delay: -0.32s;\n  }\n\n  &:nth-child(2) {\n    -webkit-animation-delay: -0.16s;\n    animation-delay: -0.16s;\n  }\n\n  @-webkit-keyframes sk-bouncedelay {\n    0%,\n    80%,\n    100% {\n      -webkit-transform: scale(0);\n    }\n    40% {\n      -webkit-transform: scale(1);\n    }\n  }\n\n  @keyframes sk-bouncedelay {\n    0%,\n    80%,\n    100% {\n      -webkit-transform: scale(0);\n      transform: scale(0);\n    }\n    40% {\n      -webkit-transform: scale(1);\n      transform: scale(1);\n    }\n  }\n\n  @-webkit-keyframes sk-bouncedelay {\n    0%,\n    80%,\n    100% {\n      -webkit-transform: scale(0);\n    }\n    40% {\n      -webkit-transform: scale(1);\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}

var LoadingWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-372f28a1-0"
})(_templateObject1(), function(param) {
    var loaded = param.loaded;
    return loaded && (0,styled_components_browser_esm.css)(_templateObject());
});
var Bouncer = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-372f28a1-1"
})(_templateObject2());


;// CONCATENATED MODULE: ./src/global/Loading/Bouncer.tsx





var Flex = ui/* Common.Flex */.Gn.Flex;
var Bouncer_Bouncer = function(param) {
    var _isLoading = param.isLoading, isLoading = _isLoading === void 0 ? true : _isLoading;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
        condition: isLoading,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Bouncer, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Bouncer, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Bouncer, {})
            ]
        })
    });
};
/* harmony default export */ var Loading_Bouncer = (Bouncer_Bouncer);

;// CONCATENATED MODULE: ./src/global/Loading/PageLoader.jsx





function PageLoader(param) {
    var loaded = param.loaded;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingWrapper, {
        loaded: loaded,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading_Bouncer, {})
    });
}
PageLoader.propTypes = {
    loaded: (prop_types_default()).bool
};
PageLoader.defaultProps = {
    loaded: false
};
// always re-render (event no visual visiblity) => need memo
/* harmony default export */ var Loading_PageLoader = (/*#__PURE__*/react.memo(PageLoader));


/***/ }),

/***/ 32447:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19521);
/* harmony import */ var _stockbit_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(76825);
/* harmony import */ var global_ErrorHandlers_If__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(29658);




function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  @keyframes rotate {\n    0% {\n      transform: rotate(0deg);\n      opacity: 1;\n    }\n    50% {\n      opacity: 0.8;\n    }\n    100% {\n      transform: rotate(360deg);\n      opacity: 1;\n    }\n  }\n\n  > div {\n    display: block;\n    margin: auto;\n    height: ",
        ";\n    width: ",
        ";\n    animation: rotate 0.8s infinite linear;\n    border-radius: 50%;\n    border: solid 1.5px ",
        ";\n    border-right-color: transparent;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var Flex = _stockbit_ui__WEBPACK_IMPORTED_MODULE_2__/* .Common.Flex */ .Gn.Flex, Text = _stockbit_ui__WEBPACK_IMPORTED_MODULE_2__/* .Common.Text */ .Gn.Text;
// eslint-disable-next-line space-infix-ops
var SecondarySpinnerDiv = styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].div.withConfig({
    componentId: "sc-45f93bc8-0"
})(_templateObject(), function(props) {
    return (props === null || props === void 0 ? void 0 : props.size) || "18px";
}, function(props) {
    return (props === null || props === void 0 ? void 0 : props.size) || "18px";
}, function(props) {
    return (props === null || props === void 0 ? void 0 : props.color) || "#6b6b6b";
});
var SecondarySpinner = function(_param) /*#__PURE__*/ {
    var _size = _param.size, size = _size === void 0 ? "18px" : _size, text = _param.text, _color = _param.color, color = _color === void 0 ? "#6b6b6b" : _color, _isLoading = _param.isLoading, isLoading = _isLoading === void 0 ? true : _isLoading, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "size",
        "text",
        "color",
        "isLoading"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(global_ErrorHandlers_If__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        condition: isLoading,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Flex, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
            direction: "column",
            justify: "center",
            align: "center"
        }, props), {
            "data-cy": "global-loading-spinner-container",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(SecondarySpinnerDiv, {
                    size: size,
                    color: color,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {})
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(global_ErrorHandlers_If__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                    condition: text,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Text, {
                        family: "light",
                        padding: "20px 0 0 0",
                        children: text
                    })
                })
            ]
        }))
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SecondarySpinner);


/***/ }),

/***/ 73580:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69396);
/* harmony import */ var zustand_vanilla__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59148);



var initialState = {
    errorCode: null,
    errorMessage: "",
    errorType: ""
};
var mainLayoutStore = (0,zustand_vanilla__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function(set) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, initialState), {
        setErrorCode: function(code) {
            var message = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", type = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "";
            set({
                errorCode: code,
                errorMessage: message,
                errorType: type
            });
        },
        resetErrorCode: function() {
            set(initialState);
        }
    });
});
/* harmony default export */ __webpack_exports__["Z"] = (mainLayoutStore);


/***/ }),

/***/ 27644:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47568);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _useTradingAccount__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(64999);





function useSecuritiesProtectedRoute() {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isLoaded = ref[0], setIsLoaded = ref[1];
    var isRealTrading = (0,_useTradingAccount__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)().isRealTrading;
    var checkAccountType = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!isRealTrading) {
                            router.push("/stream");
                        } else {
                            setIsLoaded(true);
                        }
                    case 1:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function checkAccountType() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        checkAccountType();
    }, [
        isRealTrading
    ]);
    return {
        isLoaded: isLoaded
    };
}
/* harmony default export */ __webpack_exports__["Z"] = (useSecuritiesProtectedRoute);


/***/ }),

/***/ 14229:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var constants_app__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(86123);
/* harmony import */ var date_fns_isAfter__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(42699);
/* harmony import */ var constants_localstorage__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(44252);
/* harmony import */ var features_orderbook_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51346);
/* harmony import */ var _general__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42227);





function getToken() {
    if (!(0,constants_app__WEBPACK_IMPORTED_MODULE_0__/* .isClient */ .C5)()) {
        return {
            accessToken: {
                token: null,
                expiry: null,
                isValid: null
            },
            refresh: {
                token: null,
                expiry: null,
                isValid: null
            }
        };
    }
    var ls = localStorage;
    // set cookies
    // format date from backend is still in seconds, while
    // JS' date is in miliseconds format, thus multiply the date by 1000
    var accessToken = ls[constants_localstorage__WEBPACK_IMPORTED_MODULE_3__/* .ACCESS_TOKEN_KEY */ .Wx] ? (0,_general__WEBPACK_IMPORTED_MODULE_2__/* .decodeBase64ToJS */ .OB)(ls[constants_localstorage__WEBPACK_IMPORTED_MODULE_3__/* .ACCESS_TOKEN_KEY */ .Wx]) : null;
    var accessTokenExp = ls[constants_localstorage__WEBPACK_IMPORTED_MODULE_3__/* .ACCESS_TOKEN_KEY_EXP */ .z0] ? parseInt((0,_general__WEBPACK_IMPORTED_MODULE_2__/* .decodeBase64ToJS */ .OB)(ls[constants_localstorage__WEBPACK_IMPORTED_MODULE_3__/* .ACCESS_TOKEN_KEY_EXP */ .z0]), 10) : null;
    var refreshToken = ls[constants_localstorage__WEBPACK_IMPORTED_MODULE_3__/* .REFRESH_TOKEN_KEY */ .w4] ? (0,_general__WEBPACK_IMPORTED_MODULE_2__/* .decodeBase64ToJS */ .OB)(ls[constants_localstorage__WEBPACK_IMPORTED_MODULE_3__/* .REFRESH_TOKEN_KEY */ .w4]) : null;
    var refreshTokenExp = ls[constants_localstorage__WEBPACK_IMPORTED_MODULE_3__/* .REFRESH_TOKEN_KEY_EXP */ .Nv] ? parseInt((0,_general__WEBPACK_IMPORTED_MODULE_2__/* .decodeBase64ToJS */ .OB)(ls[constants_localstorage__WEBPACK_IMPORTED_MODULE_3__/* .REFRESH_TOKEN_KEY_EXP */ .Nv]), 10) : null;
    // check expiry
    var currentTime = Date.now();
    var isAccessTokenValid = (0,date_fns_isAfter__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(accessTokenExp, currentTime);
    var isRefreshTokenValid = (0,date_fns_isAfter__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(refreshTokenExp, currentTime);
    return {
        accessToken: {
            token: accessToken,
            expiry: accessTokenExp,
            isValid: isAccessTokenValid
        },
        refresh: {
            token: refreshToken,
            expiry: refreshTokenExp,
            isValid: isRefreshTokenValid
        }
    };
}
function saveToken(param) {
    var accessToken = param.accessToken, accessTokenExp = param.accessTokenExp, refreshToken = param.refreshToken, refreshTokenExp = param.refreshTokenExp, accessUser = param.accessUser;
    if (!(0,constants_app__WEBPACK_IMPORTED_MODULE_0__/* .isClient */ .C5)()) {
        return;
    }
    if (accessUser) {
        localStorage[constants_localstorage__WEBPACK_IMPORTED_MODULE_3__/* .ACCESS_USER_KEY */ .ns] = (0,_general__WEBPACK_IMPORTED_MODULE_2__/* .encodeBase64FromJS */ .me)(accessUser);
    }
    localStorage[constants_localstorage__WEBPACK_IMPORTED_MODULE_3__/* .ACCESS_TOKEN_KEY */ .Wx] = (0,_general__WEBPACK_IMPORTED_MODULE_2__/* .encodeBase64FromJS */ .me)(accessToken);
    localStorage[constants_localstorage__WEBPACK_IMPORTED_MODULE_3__/* .ACCESS_TOKEN_KEY_EXP */ .z0] = (0,_general__WEBPACK_IMPORTED_MODULE_2__/* .encodeBase64FromJS */ .me)(accessTokenExp.toString());
    localStorage[constants_localstorage__WEBPACK_IMPORTED_MODULE_3__/* .REFRESH_TOKEN_KEY */ .w4] = (0,_general__WEBPACK_IMPORTED_MODULE_2__/* .encodeBase64FromJS */ .me)(refreshToken);
    localStorage[constants_localstorage__WEBPACK_IMPORTED_MODULE_3__/* .REFRESH_TOKEN_KEY_EXP */ .Nv] = (0,_general__WEBPACK_IMPORTED_MODULE_2__/* .encodeBase64FromJS */ .me)(refreshTokenExp.toString());
}
function updateAccessUser(accessUser) {
    if ((0,constants_app__WEBPACK_IMPORTED_MODULE_0__/* .isClient */ .C5)()) {
        localStorage[constants_localstorage__WEBPACK_IMPORTED_MODULE_3__/* .ACCESS_USER_KEY */ .ns] = (0,_general__WEBPACK_IMPORTED_MODULE_2__/* .encodeBase64FromJS */ .me)(accessUser);
    }
}
function destroyToken() {
    if ((0,constants_app__WEBPACK_IMPORTED_MODULE_0__/* .isClient */ .C5)()) {
        localStorage.removeItem(constants_localstorage__WEBPACK_IMPORTED_MODULE_3__/* .ACCESS_USER_KEY */ .ns);
        localStorage.removeItem(constants_localstorage__WEBPACK_IMPORTED_MODULE_3__/* .ACCESS_TOKEN_KEY */ .Wx);
        localStorage.removeItem(constants_localstorage__WEBPACK_IMPORTED_MODULE_3__/* .ACCESS_TOKEN_KEY_EXP */ .z0);
        localStorage.removeItem(constants_localstorage__WEBPACK_IMPORTED_MODULE_3__/* .REFRESH_TOKEN_KEY */ .w4);
        localStorage.removeItem(constants_localstorage__WEBPACK_IMPORTED_MODULE_3__/* .REFRESH_TOKEN_KEY_EXP */ .Nv);
        localStorage.removeItem("stbx-active-indexwatchlist");
        localStorage.removeItem("stbx-active-watchlist");
        localStorage.removeItem("stbx-active-widget");
        localStorage.removeItem("stbx-active-stream-header");
        localStorage.removeItem("stbx-active-stream");
        localStorage.removeItem("trade-orderbook-show-confirmation");
        localStorage.removeItem("tradeIsLogin");
        localStorage.removeItem("tradingVersion");
        localStorage.removeItem("tradingAccountType");
        localStorage.removeItem("taps");
        localStorage.removeItem("tradingBroker");
        localStorage.removeItem("lastTradingAccountType");
        localStorage.removeItem("register_trading_useractive_sinarmas");
        localStorage.removeItem("register_trading_sinarmas");
        localStorage.removeItem("register_trading_useractive");
        localStorage.removeItem("tradingBrokerList");
        localStorage.removeItem("financials-panel-amount");
        localStorage.removeItem("financials-panel-currency");
        localStorage.removeItem("financials-panel-datatype");
        localStorage.removeItem("financials-panel-lang");
        localStorage.removeItem("financials-panel-ordertype");
        localStorage.removeItem("financials-panel-reportype");
        localStorage.removeItem("financials-panel-rounding-count");
        localStorage.removeItem("financials-panel-rounding-symbol");
        localStorage.removeItem("financials-panel-statetype");
        localStorage.removeItem("crisp");
        localStorage.removeItem("formula");
        localStorage.removeItem("stbx-active-trending-date");
        localStorage.removeItem("ws");
        features_orderbook_utils__WEBPACK_IMPORTED_MODULE_1__/* .localStorageOrderbookHandler.remove */ .Ku.remove();
        localStorage.removeItem("orderbooklistID");
        localStorage.removeItem("orderbooklistName");
    }
}
/**
 * getUserAccess
 * to get user data from auth login
 * @param {*} ctx
 */ function getUserAccess() {
    return (0,constants_app__WEBPACK_IMPORTED_MODULE_0__/* .isClient */ .C5)() && localStorage && localStorage[constants_localstorage__WEBPACK_IMPORTED_MODULE_3__/* .ACCESS_USER_KEY */ .ns] ? (0,_general__WEBPACK_IMPORTED_MODULE_2__/* .decodeBase64ToJS */ .OB)(localStorage[constants_localstorage__WEBPACK_IMPORTED_MODULE_3__/* .ACCESS_USER_KEY */ .ns]) : {};
}
var setLocalCrispSettings = function(crisp) {
    localStorage.location = window.location.origin;
    localStorage.crisp = (0,_general__WEBPACK_IMPORTED_MODULE_2__/* .encodeBase64FromJS */ .me)(crisp);
};
var setLocalIntercomSettings = function(intercom) {
    localStorage.location = window.location.origin;
    localStorage.intercom = (0,_general__WEBPACK_IMPORTED_MODULE_2__/* .encodeBase64FromJS */ .me)(intercom);
};
/* harmony default export */ __webpack_exports__["Z"] = ({
    getToken: getToken,
    saveToken: saveToken,
    destroyToken: destroyToken,
    getUserAccess: getUserAccess,
    updateAccessUser: updateAccessUser,
    setLocalCrispSettings: setLocalCrispSettings,
    setLocalIntercomSettings: setLocalIntercomSettings
});


/***/ }),

/***/ 42227:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BF": function() { return /* binding */ isMobileVersion; },
/* harmony export */   "C9": function() { return /* binding */ getLastSlashURL; },
/* harmony export */   "CB": function() { return /* binding */ convertTimeZone; },
/* harmony export */   "Ex": function() { return /* binding */ saveObject; },
/* harmony export */   "FD": function() { return /* binding */ emptyObject; },
/* harmony export */   "GD": function() { return /* binding */ convertToEventValue; },
/* harmony export */   "Gf": function() { return /* binding */ sanitizeHTMLTags; },
/* harmony export */   "OB": function() { return /* binding */ decodeBase64ToJS; },
/* harmony export */   "St": function() { return /* binding */ parseCountAbbrv2; },
/* harmony export */   "TE": function() { return /* binding */ copyTextToClipboard; },
/* harmony export */   "Tk": function() { return /* binding */ handleErrorAvatar; },
/* harmony export */   "fm": function() { return /* binding */ capitalizeFirstLetter; },
/* harmony export */   "hB": function() { return /* binding */ popupWindowToCenter; },
/* harmony export */   "hr": function() { return /* binding */ escapeRegExp; },
/* harmony export */   "k6": function() { return /* binding */ convertToSlug; },
/* harmony export */   "ko": function() { return /* binding */ replaceAll; },
/* harmony export */   "lz": function() { return /* binding */ sanitizeURL; },
/* harmony export */   "me": function() { return /* binding */ encodeBase64FromJS; },
/* harmony export */   "pV": function() { return /* binding */ getColorBasedOnNumber; },
/* harmony export */   "r$": function() { return /* binding */ capitalizer; },
/* harmony export */   "rK": function() { return /* binding */ transformAvatarUrl; }
/* harmony export */ });
/* unused harmony exports sortAlpha, decodeHtml, getAreaTimeZone, setCharAt, timeZoneConvert, newlineToBr, getPathFromUrl, trimText */
/* harmony import */ var js_base64__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52300);
/* harmony import */ var moment_timezone__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(80008);
/* harmony import */ var moment_timezone__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(moment_timezone__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var constants_api__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(37213);
/* harmony import */ var constants_successMessage__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41208);
/* harmony import */ var global_AlertErrorMessage__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(25516);
/* harmony import */ var _stockbit_ui__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(76825);
/* eslint-disable no-restricted-syntax */ /* eslint-disable indent */ /* eslint-disable no-param-reassign */ /* eslint-disable no-useless-escape */ /* eslint-disable no-restricted-globals */ /* eslint-disable no-nested-ternary */ /* eslint-disable wrap-iife */ 





/* eslint-disable import/prefer-default-export */ var copyTextToClipboard = function(text) {
    var customAlert = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    var input = document.createElement("input");
    input.setAttribute("type", "text");
    var body = document.querySelector("body");
    input.value = text;
    body.appendChild(input);
    input.select();
    document.execCommand("copy");
    body.removeChild(input);
    if (customAlert) {
        customAlert();
    } else {
        (0,global_AlertErrorMessage__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)("Link copied", constants_successMessage__WEBPACK_IMPORTED_MODULE_3__/* ["default"].ALERT_GREEN */ .Z.ALERT_GREEN);
    }
};
function isMobileVersion() {
    var check = false;
    // eslint-disable-next-line func-names
    (function(a) {
        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) {
            check = true;
        }
    })(navigator.userAgent || navigator.vendor || window.opera);
    return check;
}
function popupWindowToCenter(url, title, w, h) {
    // Fixes dual-screen position                         Most browsers      Firefox
    var dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : screen.left;
    var dualScreenTop = window.screenTop !== undefined ? window.screenTop : screen.top;
    var width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
    var height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;
    var left = width / 2 - w / 2 + dualScreenLeft;
    var top = height / 2 - h / 2 + dualScreenTop;
    var newWindow = window.open(url, title, "scrollbars=yes, width=".concat(w, ", height=").concat(h, ", top=").concat(top, ", left=").concat(left));
    // Puts focus on the newWindow
    if (window.focus) {
        newWindow.focus();
    }
}
function getLastSlashURL(url) {
    return url.substr(url.lastIndexOf("/") + 1);
}
function handleErrorAvatar(e, paramUsername) {
    var fallbackUrl = "".concat(constants_api__WEBPACK_IMPORTED_MODULE_2__/* .SITE_URL */ ._O, "/images/avatar.png");
    e.target.onerror = null;
    e.target.src = fallbackUrl;
}
function parsePureValueSep(pv) {
    if (typeof pv !== "number") pv = parseFloat(pv);
    return parseFloat(pv.toFixed(2)).toLocaleString("en-US");
}
var parseCountAbbrv2 = function(number, decPlaces) {
    var thoSep = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : ",";
    var result = 0;
    if (typeof decPlaces !== "number") decPlaces = 3;
    // 2 decimal places => 100, 3 => 1000, etc
    decPlaces = Math.pow(10, decPlaces);
    // Enumerate number abbreviations
    var abbrev = [
        "K",
        "M",
        "B"
    ];
    var oldNumber = number;
    // Go through the array backwards, so we do the largest first
    for(var i = abbrev.length - 1; i >= 0; i -= 1){
        // Convert array index to "1000", "1000000", etc
        var size = Math.pow(10, (i + 1) * 3);
        // If the number is bigger or equal do the abbreviation
        if (size <= number) {
            // Here, we multiply by decPlaces, round, and then divide by decPlaces.
            // This gives us nice rounding to a particular decimal place.
            number = Math.round(number * decPlaces / size) / decPlaces;
            // Handle special case where we round up to the next abbreviation
            if (number === 1000 && i < abbrev.length - 1) {
                number = 1;
                i += 1;
            }
            // Add the letter for the abbreviation
            number += " ".concat(abbrev[i]);
            break;
        }
    }
    var raw = [];
    if (number) {
        number = number.toString();
        raw = number.split(" ");
        if (raw[0] && raw[1]) {
            result = parsePureValueSep(raw[0]);
            result = raw[1] && raw[1] !== "K" ? "".concat(result, " ").concat(raw[1]) : result;
            if (raw[1] === "K") {
                result = parseFloat(oldNumber);
                result = parsePureValueSep(result);
            }
        } else {
            result = number;
        }
    }
    return result;
};
function sortAlpha(a, b) {
    var ax = a.toLowerCase();
    var bx = b.toLowerCase();
    return ax < bx ? -1 : ax > bx ? 1 : 0;
}
/**
 * Convert data to event change data to be used in `useForm` hooks
 * @param {*} val
 * @returns {Object}
 */ var convertToEventValue = function(val) {
    var data = {
        target: {
            value: val
        }
    };
    return data;
};
/**
 * Decode string to html text area
 * @param {string} html
 * @return {string}
 */ function decodeHtml(html) {
    var textarea = document.createElement("textarea");
    textarea.innerHTML = html;
    return textarea.value;
}
/**
 * Convert text to slug
 * @param {string} text
 * @return {string}
 */ function convertToSlug(text) {
    if (!text) return text;
    return text.toString().toLowerCase().replace(/\s+/g, "-") // Replace spaces with -
    .replace(/[^\w\-]+/g, "") // Remove all non-word chars
    .replace(/\-\-+/g, "-") // Replace multiple - with single -
    .replace(/^-+/, "") // Trim - from start of text
    .replace(/-$/, ""); // Trim - from end of text
}
/**
 * Capitalize
 * @param {string} string
 * @return {string}
 */ function capitalizeFirstLetter(string) {
    if (!string) return string;
    var newString = string.toLowerCase();
    return newString.charAt(0).toUpperCase() + newString.slice(1);
}
function setCharAt(str, index, chr) {
    if (index > str.length - 1) return str;
    return str.substring(0, index) + chr + str.substring(index + 1);
}
/**
 * Capitalizer
 * @param {string} string
 * @param {number} at
 * @return {string}
 */ function capitalizer(string) {
    var at = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    if (!string) return string;
    var upperCasedLetter = string.charAt(at).toUpperCase();
    return setCharAt(string, at, upperCasedLetter);
}
// helpers
var encodeBase64FromJS = function(object) {
    var result = object;
    if (typeof object === "object") {
        result = JSON.stringify(object);
    }
    return js_base64__WEBPACK_IMPORTED_MODULE_0__/* .Base64.encode */ .DS.encode(result);
};
var decodeBase64ToJS = function(base64) {
    var decoded = js_base64__WEBPACK_IMPORTED_MODULE_0__/* .Base64.decode */ .DS.decode(base64);
    var result = decoded;
    try {
        result = JSON.parse(decoded);
    } catch (e) {
        result = decoded;
    }
    return result;
};
// local storage utils
var saveObject = function(key, object) {
    window.localStorage.setItem("location", window.location.origin);
    window.localStorage.setItem(key, encodeBase64FromJS(object));
};
/**
 * Get time zone string that is consumed by moment.js function
 * @param {string} country
 * @returns {string}
 */ function getAreaTimeZone(country) {
    var zone = "";
    switch(country){
        case "ID":
            zone = "Asia/Jakarta";
            break;
        case "MY":
            zone = "Asia/Kuala_Lumpur";
            break;
        case "SG":
            zone = "Asia/Singapore";
            break;
        default:
            zone = "Asia/Jakarta";
            break;
    }
    // return 'Africa/Cairo'
    return zone;
}
/**
 * Convert time based on format passed down
 * @param {
 *   Object {
 *     datetime: string,
 *     zone: string,
 *     oldFormat: string,
 *     newFormat: string
 *   }
 * } props - properties for moment.js
 * @returns
 */ function timeZoneConvert(param) {
    var datetime = param.datetime, zone = param.zone, oldFormat = param.oldFormat, newFormat = param.newFormat;
    var format = newFormat;
    if (!newFormat) {
        format = oldFormat;
    }
    var datetimeUtc = moment_timezone__WEBPACK_IMPORTED_MODULE_1___default()(datetime, oldFormat).utc().format();
    if (!moment_timezone__WEBPACK_IMPORTED_MODULE_1___default()(datetimeUtc).isValid()) {
        return datetime;
    }
    return moment_timezone__WEBPACK_IMPORTED_MODULE_1___default().tz(datetimeUtc, zone).format(format);
}
/**
 * Convert time using moment.js
 * @param {string} datetime
 * @param {string=} country
 * @param {string=} newformat
 * @param {string=} oldformat
 * @returns {string}
 */ function convertTimeZone(datetime, country, newformat, oldformat) {
    var newFormat = "DD MMM YY, HH:mm";
    var oldFormat = "YYYY-MM-DD HH:mm:ss";
    if (newformat) {
        newFormat = newformat;
    }
    if (oldFormat) {
        oldFormat = oldformat;
    }
    var zone = getAreaTimeZone(country);
    var lastMessageDate = timeZoneConvert({
        datetime: datetime,
        zone: zone,
        oldFormat: oldFormat,
        newFormat: newFormat
    });
    return moment_timezone__WEBPACK_IMPORTED_MODULE_1___default()(lastMessageDate).isValid() ? lastMessageDate : datetime;
}
/**
 * Turn newline into <br/>
 * @param {string} str
 * @param {string=} isXhtml
 * @returns {string}
 */ function newlineToBr(str, isXhtml) {
    var breakTag = isXhtml || typeof isXhtml === "undefined" ? "<br />" : "<br>";
    return "".concat(str).replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, "$1".concat(breakTag, "$2"));
}
function emptyObject(obj) {
    return obj && Object.keys(obj).length === 0 && obj.constructor === Object;
}
function escapeRegExp(string) {
    return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"); // $& means the whole matched string
}
function replaceAll(str, match, replacement) {
    return str.replace(new RegExp(escapeRegExp(match), "g"), function() {
        return replacement;
    });
}
var getColorBasedOnNumber = function(number) {
    if (Number(number) > 0) return _stockbit_ui__WEBPACK_IMPORTED_MODULE_5__/* .color.primary */ .$_.primary;
    if (Number(number) < 0) return _stockbit_ui__WEBPACK_IMPORTED_MODULE_5__/* .color.sunsetOrange */ .$_.sunsetOrange;
    return _stockbit_ui__WEBPACK_IMPORTED_MODULE_5__/* .color.highempahis */ .$_.highempahis;
};
function getPathFromUrl(url) {
    return url.split("?")[0];
}
function trimText(description, maxLength) {
    var trimmedString = description.substr(0, maxLength);
    var lastStringIndex = Math.min(trimmedString.length, trimmedString.lastIndexOf(" "));
    trimmedString = trimmedString.substr(0, lastStringIndex);
    if (description.length > maxLength) {
        trimmedString += "...";
    }
    return trimmedString;
}
var transformAvatarUrl = function() {
    var avatarUrl = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    if (avatarUrl.startsWith("http")) {
        return avatarUrl;
    }
    return "".concat(constants_api__WEBPACK_IMPORTED_MODULE_2__/* .AVATAR_URL */ .q$, "/").concat(avatarUrl);
};
/**
 * sanitizeHTMLTags
 * Remove Curve Brackets from string
 * to prevent xss, security issues
 *
 * This function is created because regex "/(<([^>]+)>)/gi" that already
 * used in v2 is not accepted in sonar-scan v3.
 * This function already have unit test
 * to makesure the result same as the previous regex implementation.
 * @param {String} originalString
 * @returns
 */ var sanitizeHTMLTags = function() {
    var originalString = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    var result = "";
    var start = 0;
    while(true){
        var startBracket = originalString.indexOf("<", start);
        if (startBracket === -1) break;
        var endBracket = originalString.indexOf(">", startBracket);
        if (endBracket === -1) break;
        if (endBracket - startBracket === 1) {
            result += originalString.substring(startBracket - (startBracket - start), endBracket + 1);
        } else {
            result += originalString.substring(start, startBracket);
        }
        start = endBracket + 1;
    }
    result += originalString.substring(start);
    return result;
};
function sanitizeURL() {
    var urlToCheck = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "/";
    if (urlToCheck[0] === "/") {
        return urlToCheck;
    }
    try {
        var safeProtocol = [
            "https",
            "http"
        ];
        var safeHost = [
            "stockbit.com",
            "ui.lab.stockbit.com",
            "itunes.apple.com",
            "play.google.com", 
        ];
        var url = new URL(urlToCheck);
        if (safeProtocol.indexOf(url === null || url === void 0 ? void 0 : url.protocol) < 0) {
            throw Error("Not safe protocol: ".concat(url === null || url === void 0 ? void 0 : url.protocol));
        }
        if (safeHost.indexOf(url === null || url === void 0 ? void 0 : url.host) < 0) {
            throw Error("Not safe host: ".concat(url === null || url === void 0 ? void 0 : url.host));
        }
        return urlToCheck;
    } catch (err) {
        console.error(err);
        return constants_api__WEBPACK_IMPORTED_MODULE_2__/* .SITE_URL */ ._O;
    }
}



/***/ }),

/***/ 91635:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Iv": function() { return /* binding */ setUserId; },
/* harmony export */   "Kp": function() { return /* binding */ sentrySetUser; },
/* harmony export */   "gB": function() { return /* binding */ sentryLog; }
/* harmony export */ });
/* unused harmony export noticeError */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(82670);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var _sentry_nextjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(64487);
/* harmony import */ var _auth__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14229);
/* harmony import */ var _general__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(42227);







var setUserId = function(userId) {
    if (false) {}
    var logger = window === null || window === void 0 ? void 0 : window.NREUM;
    if (!logger || !(logger === null || logger === void 0 ? void 0 : logger.setUserId)) return;
    if (userId !== null) logger === null || logger === void 0 ? void 0 : logger.setUserId(userId.toString());
};
var noticeError = function(// eslint-disable-next-line @typescript-eslint/no-explicit-any
err, customAttr) {
    if (false) {}
    var logger = window === null || window === void 0 ? void 0 : window.NREUM;
    if (!logger) return;
    // Get User Id from localStorage
    var ref = _auth__WEBPACK_IMPORTED_MODULE_0__/* ["default"].getUserAccess */ .Z.getUserAccess() || {}, userId = ref.id;
    // Set New Relic User Id
    if (err) {
        setUserId(userId || null);
        var mappedCustomAttr;
        try {
            mappedCustomAttr = Object.keys(customAttr).reduce(function(a, key) {
                var newKey = key.startsWith("sb") ? (0,_general__WEBPACK_IMPORTED_MODULE_1__/* .capitalizer */ .r$)(key, 2) : "sb".concat((0,_general__WEBPACK_IMPORTED_MODULE_1__/* .capitalizer */ .r$)(key, 0));
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, a), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, newKey, customAttr[key]));
            }, {});
        } catch (error) {
            mappedCustomAttr = customAttr;
        }
        logger.noticeError(err, mappedCustomAttr);
    }
};
/* harmony default export */ __webpack_exports__["ZP"] = (noticeError);
var sentryLog = function(options) {
    var error = options.error, scopeName = options.scope, level = options.level, username = options.username, httpStatusCode = options.httpStatusCode, tags = options.tags;
    _sentry_nextjs__WEBPACK_IMPORTED_MODULE_5__/* .withScope */ .$e(function(scope) {
        scope.setTag("scope", scopeName);
        scope.setLevel(level);
        if (httpStatusCode) {
            scope.setTag("http-status-code", httpStatusCode);
        }
        if (Array.isArray(tags) && tags.length > 0) {
            tags.forEach(function(item) {
                scope.setTag(item.title, item.value);
            });
        }
        if (username) {
            scope.setUser({
                username: username
            });
        }
        if (typeof error === "string") {
            _sentry_nextjs__WEBPACK_IMPORTED_MODULE_5__/* .captureMessage */ .uT(error);
        }
        if ((0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(error, Error)) {
            _sentry_nextjs__WEBPACK_IMPORTED_MODULE_5__/* .captureException */ .Tb(error);
        }
    });
};
var sentrySetUser = function(isLoggedIn) {
    if (!isLoggedIn) {
        return;
    }
    var userData = _auth__WEBPACK_IMPORTED_MODULE_0__/* ["default"].getUserAccess */ .Z.getUserAccess();
    _sentry_nextjs__WEBPACK_IMPORTED_MODULE_5__/* .setUser */ .av({
        username: userData === null || userData === void 0 ? void 0 : userData.username,
        id: userData === null || userData === void 0 ? void 0 : userData.id
    });
};


/***/ }),

/***/ 22868:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 14777:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 99830:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 70209:
/***/ (function() {

/* (ignored) */

/***/ })

}]);